import React, { useState, useEffect } from 'react';
import { projectFirestore } from '../firebase/config';

const AnnouncementBar = () => {
    const [data, setData] = useState(null);

    useEffect(() => {
        const unsub = projectFirestore.collection('settings').doc('announcements')
            .onSnapshot((doc) => {
                if (doc.exists) setData(doc.data());
            });
        return () => unsub();
    }, []);

    if (!data || !data.enabled || !data.text) return null;

    return (
        <div className="announcement-bar">
            <div className="announcement-track">
                <span>{data.text}</span>
                <span>{data.text}</span>
            </div>
        </div>
    );
};

export default AnnouncementBar;
